import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { useLazyGetRoomSessionQuery } from '../../../../../store/media/media'
import { selectRoomSession, setRoomSession, setRoomSessionIsLoading } from '../../../../../store/meetingSummary/roomSession'
import { useCallback } from 'react'

export const useReloadRoomSession = () => {
  const dispatch = useAppDispatch()
  const accountId = useAppSelector(selectAccountId)
  const roomSession = useAppSelector(selectRoomSession)
  const [triggerGetRoomSession] = useLazyGetRoomSessionQuery()

  return useCallback(async () => {
    if (!roomSession) {
      return
    }
    const roomId = roomSession.roomId
    const sessionId = roomSession.id
    dispatch(setRoomSessionIsLoading(true))
    try {
      const { data: roomSession } = await triggerGetRoomSession(
        {
          accountId,
          roomId,
          sessionId,
        },
        false,
      )
      if (roomSession?.data) {
        dispatch(setRoomSession(roomSession.data))
      }
    } catch (e) {
      console.error(e)
    } finally {
      dispatch(setRoomSessionIsLoading(false))
    }
  }, [accountId, roomSession, dispatch, triggerGetRoomSession])
}
